import { Injectable } from "@angular/core";
import { DataService } from "./data.service";

@Injectable()
export class DepartmentBookingService {
    constructor(private dataService: DataService) {
    };
    getBookingFor(refresh: boolean) {
        return this.dataService.getData('/api/lookup/departmentbookingtype', refresh)
    }
    getScheme(refresh: boolean) {
        return this.dataService.getData('/api/department/scheme', refresh)
    }
    getDepartmentName(data: any) {
        return this.dataService.getData('/api/department/lookup/' + data, true)
    }
    getMachineryList(data: any) {
        return this.dataService.getData('/api/department/vehicleListBySubDivision/' + data.subDivisionId + '/' + data.langType, true)
    }
    getMachineryByRegNo(data: any) {
        return this.dataService.getData('/api/vehicle/vehiclelookup/' + data.subDivisionId, true)
    }
    getMachineryByRegNoForDepartment(data: any) {
        return this.dataService.getData('/api/vehicle/vehiclelookup/dept/' + data.subDivisionId, true)
    }
    getImplement(data: any) {
        return this.dataService.getData('/api/implement/lookup/' + data.subDivisionId, true)
    }
    getImplementAll(data: any) {
        return this.dataService.getData('/api/implement/allList/' + data.subDivisionId, true)
    }
    checkvehicleAvailability(data: any) {
        return this.dataService.post('/api/department/vehicleavailablecheck', data)
    }
    getDepartmentBookingList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/department/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.bookingStatusType + '/' + data.financialYearId, refresh);
    }
    getBreakDownImplementList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/department/departmentImplement/' + data.region + '/' + data.division + '/' + data.subdivision  + '/' + data.financialYearId, refresh);
    }
    departmentBookingSave(data: any) {
        return this.dataService.post('/api/department/departmentBookingSave', data)
    }
    departmentPaymentUpdate(data: any) {
        return this.dataService.post('/api/department/departmentPaymentUpdate', data)
    }
    departmentBookingUpdate(data: any) {
        return this.dataService.post('/api/department/departmentUpdateallocation',data)
    }
    goToFileEdit(bookingId: any, refresh: boolean) {
        return this.dataService.getData('/api/department/' + bookingId, refresh)
    }

    goToImplmentBreakdownEdit(id: any, refresh: boolean) {
        return this.dataService.getData('/api/department/departmentImplement/' + id, refresh)
    }

    getLookUpTypeOfPayment(refresh: boolean) {
        return this.dataService.getData('/api/lookup/departmentpaymenttype/', refresh);
    }
    departmentBookingImplementSave(data: any) {
        return this.dataService.post('/api/department/departmentImplementSave',data)
    }
    getBookingStatusList(refresh: boolean) {
        return this.dataService.getData("/api/mhire/bookingstatustype", refresh);
    }

    getAppConfigByKey(key: string) {
        return this.dataService.getData('/api/config/' + key, true);
    }

}
